import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const commentsRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.comments.route,
      lazy: () => import("@pages/panelPages/comments/comments"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.comments", [], "index", "main");
        return {};
      },
    },
    permissions: ["local-admin", "admin", "super-admin"],
  },
];
